/*
 * Pets Garden — "Aggiungi al carrello" delle card prodotto e della barra fissa.
 *
 * Sostituisce lo script che il tema copiava in ogni card (36 copie in home) e
 * che inviava DUE richieste a /cart/add.js per clic (quantità raddoppiata;
 * x4 sulle pagine prodotto, dove plugins.js aggiungeva un altro gestore).
 * Qui: un solo gestore per tutta la pagina, una sola richiesta per clic,
 * valido anche per le card caricate dopo (correlati, filtri, paginazione).
 */
(function () {
  if (window.pgCarrelloPronto) return;
  window.pgCarrelloPronto = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function sezione(html, selettore) {
    if (!html) return null;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selettore);
    return el ? el.innerHTML : null;
  }

  function aggiornaMiniCarrello(sections) {
    var contenuto = sezione(sections['ajax-cart'], '#ajaxcart');
    var box = document.getElementById('ajaxcart');
    if (contenuto !== null && box) box.innerHTML = contenuto;

    var contatore = sezione(sections['ajax-cart-icon'], '.bigcounter');
    if (contatore !== null) {
      document.querySelectorAll('.bigcounter').forEach(function (el) { el.innerHTML = contatore; });
    }

    var mini = document.querySelector('.mini-cart');
    if (!mini) return;
    mini.classList.remove('is-empty');
    setTimeout(function () {
      mini.classList.add('animate', 'active');
      // Checkbox "accetto i termini" del mini carrello: il contenuto è nuovo, va ricollegato
      var checkbox = document.getElementById('toggleCheckbox');
      var checkout = document.getElementById('ajaxcart-checkout');
      if (checkbox && checkout) {
        checkbox.addEventListener('change', function () {
          checkout.disabled = !checkbox.checked;
          if (checkbox.checked) checkout.setAttribute('data-custom', 'example');
          else checkout.removeAttribute('data-custom');
        });
      }
    }, 200);
  }

  // Avviso in sovrimpressione: non altera l'impaginazione della card o della barra fissa
  var toast, toastTimer;
  function mostraAvviso(testo) {
    if (!toast) {
      toast = document.createElement('div');
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      // Abbastanza in alto da non finire sotto la barra fissa né sotto il pulsante WhatsApp
      toast.style.cssText = 'position:fixed;left:50%;bottom:calc(170px + env(safe-area-inset-bottom));' +
        'transform:translateX(-50%);z-index:2147483000;max-width:min(92vw,420px);padding:12px 16px;' +
        'background:#333;color:#fff;border-radius:10px;font-size:14px;line-height:1.4;text-align:center;' +
        'box-shadow:0 6px 20px rgba(0,0,0,.25);transition:opacity .2s;opacity:0;pointer-events:none';
      document.body.appendChild(toast);
    }
    toast.textContent = testo;
    toast.style.opacity = '1';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.style.opacity = '0'; }, 5000);
  }

  // Ricarica mini carrello e contatore senza aprirlo (es. aggiunta parziale per scorta)
  function ricaricaCarrello() {
    return Promise.all([
      fetch(ROOT + '?sections=ajax-cart,ajax-cart-icon').then(function (r) { return r.ok ? r.json() : null; }),
      fetch(ROOT + 'cart.js').then(function (r) { return r.ok ? r.json() : null; }),
    ])
      .then(function (risposte) {
        var sections = risposte[0];
        var carrello = risposte[1];
        if (sections) {
          var contenuto = sezione(sections['ajax-cart'], '#ajaxcart');
          var box = document.getElementById('ajaxcart');
          if (contenuto !== null && box) box.innerHTML = contenuto;
          var contatore = sezione(sections['ajax-cart-icon'], '.bigcounter');
          if (contatore !== null) {
            document.querySelectorAll('.bigcounter').forEach(function (el) { el.innerHTML = contatore; });
          }
        }
        // Il tema nasconde il contenuto se la pagina era partita a carrello vuoto
        var mini = document.querySelector('.mini-cart');
        if (mini && carrello) mini.classList.toggle('is-empty', carrello.item_count === 0);
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('a.ajax-cart-btn[id^="pro-add-"]');
    if (!btn) return;
    e.preventDefault();
    if (btn.hasAttribute('disabled') || btn.classList.contains('loading')) return;

    // Variante e quantità lette dentro la stessa card: niente ID globali duplicati
    var ambito = btn.closest('cart-action') || btn.closest('form') || btn.parentElement;
    var idInput = ambito.querySelector('input[name="id"]');
    var qtyInput = ambito.querySelector('.qty-box-input');
    var variantId = idInput && Number(idInput.value);
    var quantita = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
    if (!variantId) return;

    var loader = btn.querySelector('.ajax-loader');
    btn.classList.add('loading');
    if (loader) loader.classList.remove('hidden');

    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: quantita }],
        sections: ['ajax-cart', 'ajax-cart-icon'],
      }),
    })
      .then(function (r) {
        return r.json().then(function (dati) { return { ok: r.ok, dati: dati }; });
      })
      .then(function (res) {
        if (!res.ok) {
          mostraAvviso(res.dati.description || res.dati.message || 'Impossibile aggiungere al carrello.');
          // Shopify può aver aggiunto una parte dei pezzi: allinea mini carrello e contatore
          return ricaricaCarrello();
        }
        aggiornaMiniCarrello(res.dati.sections || {});
        document.dispatchEvent(new CustomEvent('pg:carrello-aggiornato', { detail: res.dati }));
      })
      .catch(function (err) {
        console.error('[pg-carrello]', err);
        mostraAvviso('Connessione non riuscita. Riprova.');
      })
      .finally(function () {
        btn.classList.remove('loading');
        if (loader) loader.classList.add('hidden');
      });
  });

  // ── Prezzo della card quando si sceglie un altro formato ─────────────────
  // Il tema aggiorna la variante nel campo id del form ma non il prezzo mostrato.
  function formatoPrezzo(centesimi) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.money_format) {
      return window.Shopify.formatMoney(centesimi, window.money_format);
    }
    var valuta = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    return new Intl.NumberFormat(document.documentElement.lang || 'it', { style: 'currency', currency: valuta })
      .format(centesimi / 100);
  }

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches('cart-action input[name="id"]')) return;
    var card = input.closest('.single-product-wrap') || input.closest('cart-action');
    var dati = card && card.querySelector('selects-box script[type="application/json"]');
    var box = card && card.querySelector('.price-box');
    if (!dati || !box) return;
    var variante;
    try {
      variante = JSON.parse(dati.textContent).find(function (v) { return String(v.id) === String(input.value); });
    } catch (err) { return; }
    if (!variante) return;
    var nuovo = box.querySelector('.new-price');
    var vecchio = box.querySelector('.old-price');
    if (nuovo) nuovo.textContent = formatoPrezzo(variante.price);
    if (vecchio) {
      var scontato = variante.compare_at_price && variante.compare_at_price > variante.price;
      vecchio.textContent = scontato ? formatoPrezzo(variante.compare_at_price) : '';
      vecchio.style.display = scontato ? '' : 'none';
    }
  });
})();
